/* eslint-disable array-callback-return */
import React, {Dispatch, FC, SetStateAction} from 'react';
import {LanguageSelect} from "../LanguageSelect/LanguageSelect";
import style from "./Menu.module.css";
import {EnumFog} from "../../../../Utils/FogContainer/FogContainer";
import {pages} from "../../../../../pages/pagesConfig";
import {Link} from "react-router-dom";
import {useAppSelector} from "../../../../../hooks/redux";
import {getLanguage} from "../../../../../store/selectors/appSelector";
import ModalPortal from "../../../../../Portals/ModalPortal";

type PropsType = {
    setIsMenuShown: Dispatch<SetStateAction<boolean>>
    isMenuShown: boolean
}

const Menu: FC<PropsType> = ({isMenuShown, setIsMenuShown}) => {

    const language = useAppSelector(getLanguage)

    return (
            <ModalPortal options={{
                setStateModal: setIsMenuShown,
                fogPower: EnumFog.veryStrong,
                statusModal: isMenuShown
            }}>
                <LanguageSelect/>

                <ul className={style.menuList}>
                    {pages.map((page, index) => {
                        if (page.status && page.inNavigation) {
                            return (
                                <li key={`menu_${index}`} className={style.menuItem}>
                                    <Link to={page.path} onClick={() => setIsMenuShown(false)}>
                                        {page.title[language]}
                                    </Link>
                                </li>
                            )
                        }
                    })}
                </ul>

            </ModalPortal>
    );
};

export default Menu;